// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2fLkH","upload":"Small_upload__wL7gi","imageWrap":"Small_imageWrap__2ii_c","removeBtn":"Small_removeBtn__nJivI"};